import React from 'react';

const InvalidIcon = ({ size = '118px', color = '#fff' }) => {
  return (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 512.000000 512.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M2400 4954 c-337 -30 -600 -101 -885 -238 -486 -234 -865 -612 -1106
-1101 -329 -672 -329 -1438 0 -2110 266 -541 708 -951 1266 -1173 289 -115
562 -166 885 -166 386 0 715 76 1055 243 485 239 856 608 1090 1086 86 175
134 301 174 458 191 746 25 1519 -456 2117 -370 460 -926 776 -1523 865 -103
15 -411 27 -500 19z m167 -2160 c290 291 784 776 790 776 5 0 58 -50 118 -111
l110 -111 -400 -394 c-219 -216 -397 -395 -395 -398 3 -2 179 -180 393 -394
213 -215 387 -394 387 -399 0 -4 -47 -55 -105 -113 l-105 -104 -57 54 c-32 30
-212 208 -401 395 l-342 340 -398 -398 -397 -397 -110 110 -109 110 44 47 c25
27 202 207 395 401 l350 352 -398 398 -397 397 112 113 113 112 397 -397 c218
-218 401 -394 405 -389z'
        />
      </g>
    </svg>
  );
};

export default InvalidIcon;
